<div class="app-main">
  <h1 class="page-title">Empresas</h1>
  <p class="page-subtitle">Selecciona una empresa para ver sus sucursales</p>

  @if (loading()) {
    <div class="loading-state">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p>Cargando empresas...</p>
    </div>
  } @else if (error()) {
    <div class="empty-state">
      <p class="text-danger">{{ error() }}</p>
    </div>
  } @else if (companies().length === 0) {
    <div class="empty-state">
      <p>No hay empresas registradas.</p>
    </div>
  } @else {
    <div class="card-grid">
      @for (company of companies(); track company.idCompany) {
        <div class="entity-card" (click)="goToBranches(company)">
          <div class="entity-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
              <path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022ZM6 8.694 1 10.36V15h5V8.694ZM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15Z"/>
              <path d="M2 11h1v1H2v-1Zm2 0h1v1H4v-1Zm-2 2h1v1H2v-1Zm2 0h1v1H4v-1Zm4-4h1v1H8V9Zm2 0h1v1h-1V9Zm-2 2h1v1H8v-1Zm2 0h1v1h-1v-1Zm2-2h1v1h-1V9Zm0 2h1v1h-1v-1ZM8 7h1v1H8V7Zm2 0h1v1h-1V7Zm2 0h1v1h-1V7ZM8 5h1v1H8V5Zm2 0h1v1h-1V5Zm2 0h1v1h-1V5Zm0-2h1v1h-1V3Z"/>
            </svg>
          </div>
          <p class="entity-name">{{ company.name }}</p>
          <p class="entity-meta">Ver sucursales →</p>
        </div>
      }
    </div>
  }
</div>
